import styled, { keyframes } from 'styled-components';

const spin = keyframes`
from{
  transform: rotate(0deg);
}to{
  transform: rotate(360deg);
}
`;

const Spinner = styled.div`
  width: 48px;
  height: 48px;

  border: 2px solid #f3f3f3;
  border-top: 2px solid #55b391;
  border-radius: 100%;

  animation: ${spin} 1s infinite linear;
`;

export default Spinner;
